import addToCart from '../lib/addToCart';
import { closePopup } from '../utils/popupController';
import renderMinicart from '../lib/renderMinicart';
import { SELECTORS } from '../utils/constants';
import updateCart from '../lib/updateCart';
import { validateRequiredChoices } from './product-choices';

const initAtcForm = (isPopup = false) => {
  const atcForms = document.querySelectorAll('[data-product-form]');
  if (!atcForms.length) return;

  const setBtnLoadingState = (button, spinner, loading) => {
    button.classList.toggle('pointer-events-none', loading);
    button.classList.toggle('opacity-50', loading);
    if (spinner) spinner.classList.toggle('hidden', !loading);
  };

  const getItem = (form) => {
    const variantId = +form.id.value;
    const quantity = +form.elements['quantity'].value;

    const sellingPlanEl = form.elements['selling_plan'];
    const sellingPlan = sellingPlanEl && sellingPlanEl.value !== '' ? +sellingPlanEl.value : null;

    return [variantId, quantity, sellingPlan];
  };

  const getFieldsByPrefix = (form, prefix) => {
    const inputs = form.querySelectorAll(`[name^="${prefix}["]`);
    const fields = {};
    const namePattern = new RegExp(`^${prefix}\\[(.+)\\]$`);

    inputs.forEach((input) => {
      if (input.disabled) return;
      const match = input.name.match(namePattern);
      if (match) {
        const key = match[1];
        fields[key] = input.value;
      }
    });
    return fields;
  };

  const getAttributes = (form) => getFieldsByPrefix(form, 'attributes');

  const getProperties = (form) => getFieldsByPrefix(form, 'properties');

  const addVariantToCart = async (evt) => {
    evt.preventDefault();
    if (!validateRequiredChoices(evt.target)) return;
    const submitBtnSpinner = evt.submitter?.querySelector(SELECTORS.LOADING_SPINNER);
    setBtnLoadingState(evt.submitter, submitBtnSpinner, true);
    try {
      const [variantId, quantity, sellingPlan] = getItem(evt.target);
      const attributes = getAttributes(evt.target);
      const properties = getProperties(evt.target);
      await addToCart(variantId, quantity, sellingPlan, properties);
      if (attributes) {
        await updateCart(attributes);
      }
      await renderMinicart();
      if (isPopup) closePopup();
      window.theme.minicart?.open();
    } catch (error) {
      console.error('Error adding variant to cart:', error);
    } finally {
      setBtnLoadingState(evt.submitter, submitBtnSpinner, false);
    }
  };

  atcForms.forEach(form => {
    if (form.dataset.eventsBound === 'true') return;
    form.dataset.eventsBound = 'true';
    form.addEventListener('submit', addVariantToCart);
  });
};

export default initAtcForm;
